import { useAccess } from "../../../../../../../../../../context/useAccess";
import { decodeHtml } from "../../../../../../../../../../services/Afins";
import { obterLogo } from "../capa/meta";
import { PaginaAviso } from "./style";

//PROPS
interface Props {
    mensagem: string;
    logo: any;
}

export const Aviso: React.FC<Props> = ({ mensagem, logo }) => {

    const { consultoria } = useAccess();

    return (
        <PaginaAviso>
            
            <div
                className='PaginaAviso__mensagem'
                dangerouslySetInnerHTML={{
                    __html: decodeHtml(mensagem)
                }}
            />

            <img src={obterLogo() ?? consultoria.logo_url} alt="logo" className="PaginaAviso__logo" />

        </PaginaAviso>
    )
};

